import Vue from 'vue';
import * as appUtils from '@/util/appUtils';
import numeral from 'numeral';
import {
  FIELD_TYPE_CASCADER,
  FIELD_TYPE_POP_ONE,
  FIELD_TYPE_CHECKBOX,
  FIELD_TYPE_CHECKBOX_GROUP,
  FIELD_TYPE_DATE,
  FIELD_TYPE_POP_MULTI,
  FIELD_TYPE_LIST_POP_MULTI,
  FIELD_TYPE_DATERANGE,
  FIELD_TYPE_MONTH,
  FIELD_TYPE_DATETIME,
  FIELD_TYPE_LIST_POP_ONE,
  FIELD_TYPE_DATETIME_RANGE,
  FIELD_TYPE_FILE,
  FIELD_TYPE_YEAR,
  FIELD_TYPE_INPUT,
  FIELD_TYPE_MULTIPLE_SELECT,
  FIELD_TYPE_RADIO,
  FIELD_TYPE_SELECT,
  FIELD_TYPE_TIME_RANGE,
  FIELD_TYPE_EMPTY, FIELD_TYPE_SWITCH
} from '@/util/x-condition-constant';
import {MessageBox, Notification} from 'element-ui';
import { isEnter } from '@/util/keyCode';
import {SIMPLE, SINGLE_SELECT} from '@/mixin/search-dialog-mixin';
import { api as viewerApi } from 'v-viewer';
import {getListItem, getLeafList} from '@/util/componentCoreUtil';
import PDF_ICON from '../assets/PDF.png';
import PPT_ICON from '../assets/PPT.png';
import EXCEL_ICON from '../assets/EXCEL.png';
import WORD_ICON from '../assets/WORD.png';
import ZIP_ICON from '../assets/ZIP.png';
import TXT_ICON from '../assets/TXT.png';
import UNKNOWN_FILE_ICON from '../assets/UNKNOWN_FILE.png';
import APK from '../assets/APK.png';
import { downloadFile } from './downloadFile';
import XUploadDialog from '@/component/x-upload-dialog/x-upload-dialog.vue';
import {
  booleanOptions, depositOut,
  plotStatusClaimable,
  plotStatusOptions,
  progressOptions,
  reviewProgressOptions,
  statusEffective,
  statusOptions,
  typeOptions
} from '@/util/common-constant';
import {get} from './storage';
import {getUrlWithSign, stringify} from './url';
import {hasRight} from "@/util/user";
import {
  convertBigDigit,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  DATE_TIME_SHORT_FORMAT,
  isEmpty, isNotEmpty,
  isString
} from '@/util/appUtils';
import request from '@/util/request2';
import {plApplyPager, plPlotPager, vegPagerWithFee} from '@/api/sysApi';
import PromptDialog from '@/component/prompt-dialog/prompt-dialog.vue'
const PromptDialogConstructor = Vue.extend(PromptDialog);

/**
 * 5位小数
 * @type {string}
 */
export const FLOAT_FORMAT_5 = '0.00000';
/**
 * 4位小数
 * @type {string}
 */
export const FLOAT_FORMAT_4 = '0.0000';
/**
 * 3位小数
 * @type {string}
 */
export const FLOAT_FORMAT_3 = '0.000';

/**
 * 上一单和下一单的路由模式 params
 * @type {string}
 */
export const ROUTE_TYPE_PARAMS = 'params';
/**
 * 上一单和下一单的路由模式 query
 * @type {string}
 */
export const ROUTE_TYPE_QUERY = 'query';

/**
 * 获取日期时间格式化函数
 * @param format
 * @return {(function({cellValue: *}): (*))|*}
 */
export const getDateFormatter = ({format}) => {
  return ({cellValue}) => {
    if (appUtils.isEmpty(cellValue)) {
      return cellValue;
    }
    if (!format) {
      return cellValue;
    }
    if (!Number.isNaN(cellValue)) {
      // 纯数字是毫秒数，根据format来转换
      return appUtils.dateFormat(format, new Date(cellValue));
    }
    // 字符串目前先直接根据长度来处理
    return cellValue.substring(0, format.length);
  };
};

/**
 * @desc 创建表格行操作按钮的VNode
 * @param data
 * @param item
 * @param createElement
 * @returns {*}
 */
export function renderTableOperateItemTemplate(data, item, createElement) {
  const classList = ['table-operate-item'];
  if (item.className) {
    if ((typeof item.className).toLowerCase() === 'string' || item.className instanceof String) {
      classList.push(item.className);
    } else if (Array.isArray(item.className)) {
      classList.push(...item.className);
    } else {
    }
  }
  return createElement(
    'span',
    {
      class: classList,
      on: {
        mousedown: e => {
          e.stopPropagation();
          if (Object.prototype.hasOwnProperty.call(item, 'disabled') && item.disabled === true) {
            return;
          }
          if (item.disabledMethod) {
            const disabled = item.disabledMethod({ data, item });
            if (disabled === true) {
              return;
            }
          }
          item.click && item.click({ item, data, row: data.row });
        }
      }
    },
    item.name
  );
}

/**
 * @desc 创建表格行操作列的VNODE数组
 * @param data
 * @param config
 * @param createElement
 * @returns {array}
 */
export function renderTableOperateTemplate(data, config, createElement) {
  const list = [];
  if (!Array.isArray(config.list)) {
    return list;
  }
  const showList = [];
  for (const item of config.list) {
    if (!Object.prototype.hasOwnProperty.call(item, 'show')) {
      showList.push(item);
      continue;
    }
    const show = item.show;
    if ((appUtils.isBoolean(show) && show) || (appUtils.isFunction(show) && show({ item, data }))) {
      showList.push(item);
    }
  }
  // 默认显示4个
  let limit = 4;
  if (Object.prototype.hasOwnProperty.call(config, 'limit')) {
    limit = config.limit;
  }
  if (showList.length <= limit) {
    for (const item of showList) {
      list.push(renderTableOperateItemTemplate(data, item, createElement));
    }
    // return [createElement('div', {'class': ['table-operate']}, list)];
    return list;
  }
  for (let i = 0; i < limit; i++) {
    list.push(renderTableOperateItemTemplate(data, showList[i], createElement));
  }
  const dropdownList = [];
  for (let i = limit; i < showList.length; i++) {
    dropdownList.push(
      createElement('el-dropdown-item', [
        renderTableOperateItemTemplate(data, showList[i], createElement)
      ])
    );
  }
  list.push(
    createElement('el-dropdown', [
      createElement('span', { class: ['table-operate-item'] }, '更多操作'),
      createElement('el-dropdown-menu', { slot: 'dropdown' }, dropdownList)
    ])
  );
  // return [createElement('div', {'class': ['table-operate']}, list)];
  return list;
}

/**
 * @desc 计算表格行操作列宽度，这个只是估算宽度，
 * 开发者如果需要精确的宽度需要手动计算每个按钮的宽度和margin等信息
 * @param config
 * @returns {number}
 */
export function getOperateColumnWidth(config) {
  let limit = 3;
  // 预设每个按钮自身和margin-left共70px,如更多操作，font-size:12px, margin-left:10px
  const itemWidth = 70;
  if (!Array.isArray(config.list)) {
    return limit * itemWidth;
  }
  if (Object.prototype.hasOwnProperty.call(config, 'limit')) {
    limit = config.limit;
  }
  return (config.list.length < limit ? limit * itemWidth : limit + 1) * itemWidth;
}

/**
 * 获取label对应的item
 * @param list
 * @param label
 * @return {null|any}
 */
export function getPageFooterItem({ list, label }) {
  return getListItem({
    list,
    callback: item => {
      return item.label === label;
    }
  });
}

/**
 * 获取单个button的配置数据
 * @param list
 * @param name
 * @return {null}
 */
export function getButtonItem({ list, name }) {
  let button = null;
  function getButtonItemRecursive({ list, name }) {
    if (!Array.isArray(list)) {
      return null;
    }
    for (const item of list) {
      if (item.name === name) {
        button = item;
        return;
      }
      if (Array.isArray(item.children)) {
        getButtonItemRecursive({ list: item.children, name });
      }
    }
  }
  getButtonItemRecursive({ list, name });
  return button;
}

/**
 * @desc 获取校验规则
 * @param list
 * @return {{}}
 */
export function getConditionRules({ list }) {
  const rules = {};
  for (const item of list) {
    if (!item.required) {
      continue;
    }
    const rule = { required: true };
    rules[item.field] = [rule];
    if (FIELD_TYPE_INPUT === item.type || item.type === 'number') {
      rule.message = item.placeholder ? item.placeholder : '请输入' + item.label;
      rule.trigger = 'blur';
    } else {
      rule.message = item.placeholder ? item.placeholder : '请选择' + item.label;
      rule.trigger = 'change';
    }
  }
  return rules;
}

/**
 * @desc 在buttonConfig查找slot项并返回
 * @param buttonConfig
 * @return {array}
 */
export function getButtonSlotArray(buttonConfig) {
  const arr = [];
  if (!buttonConfig) {
    return arr;
  }
  function getButtonSlotArrayRecursive(list) {
    if (!Array.isArray(list)) {
      return;
    }
    for (const item of list) {
      if (item.slot) {
        arr.push(item.slot);
        continue;
      }
      getButtonSlotArrayRecursive(item.children);
    }
  }
  getButtonSlotArrayRecursive(buttonConfig.list);
  return arr;
}

/**
 * @desc 获取一般性编辑状态下的输入框
 * @param props
 * @param immediate
 * @param name
 * @param enabled
 * @return {object}
 */
export function getInputEditRender({
  props = { placeholder: '请输入', clearable: true, maxlength: 500 },
  immediate = true,
  name = 'ElInput',
  enabled = true
} = {}) {
  return {
    name,
    immediate,
    props,
    enabled
  };
}

/**
 * @desc 获取一般性编辑状态下的日期选择
 * @param props
 * @param immediate
 * @param name
 * @param enabled
 * @return {object}
 */
export function getDateEditRender(
  {
    props = { placeholder: '请选择', valueFormat: DATE_FORMAT, clearable: true },
    immediate = true,
    name = 'ElDatePicker',
    enabled = true
} = {}) {
  return {
    name,
    immediate,
    props,
    enabled
  };
}

/**
 * @desc 获取一般性编辑状态下的下拉选择框
 * @param name
 * @param props
 * @param options
 * @param optionProps
 * @param enabled
 * @param events
 * @return {object}
 */
export function getSelectEditRender({
  name = 'ElSelect',
  props = { placeholder: '请选择', filterable: true, clearable: true, multiple: false },
  options,
  optionProps = { value: 'value', label: 'label', key: 'value' },
  enabled = true,
  events
} = {}) {
  return {
    name,
    props,
    options,
    optionProps,
    enabled,
    events
  };
}

/**
 * 获取一般性的选择框，因为默认和编辑状态下都需要显示选择框，因此在default中实现
 * @return {object}
 */
export function getRadioSlots() {
  return {
    default: getRadioSlotDefault()
  };
}

/**
 * 获取一般性的选择框
 * @return {function}
 */
export function getRadioSlotDefault() {
  return (scope, createElement) => {
    return [
      createElement('vxe-checkbox', {
        props: { value: scope.row[scope.column.field] },
        on: {
          change: ({ checked }) => {
            scope.row[scope.column.field] = checked;
          }
        }
      })
    ];
  };
}

/**
 * 获取一般性的多选框，因为默认和编辑状态下都需要显示选择框，因此在default中实现
 * @return {object}
 */
export function getCheckboxSlots({ name = 'vxe-checkbox', props } = {}) {
  return {
    default: getCheckboxSlotDefault({ name, props })
  };
}

/**
 * 获取一般性的单选框
 * @param name
 * @param props
 * @return {function}
 */
export function getCheckboxSlotDefault({ name = 'vxe-checkbox', props } = {}) {
  return (scope, createElement) => {
    const realProps = { value: scope.row[scope.column.field] };
    if (props) {
      Object.assign(realProps, props);
    }
    return [
      createElement(
        'div',
        {
          class: 'cell-checkbox-wrapper'
        },
        [
          createElement(name, {
            props: realProps,
            class: 'cell-checkbox',
            on: {
              change: (...args) => {
                if (name === 'vxe-checkbox') {
                  scope.row[scope.column.field] = args[0].checked;
                }
                if (name === 'el-checkbox') {
                  scope.row[scope.column.field] = args[0];
                }
              }
            }
          })
        ]
      )
    ];
  };
}

/**
 * @desc 获取InputFilter的预设值
 * @param data
 * @return {object}
 */
export function getInputFilters({ data = '' } = {}) {
  return [{ data }];
}

/**
 * @desc 获取一般的InputFilter
 * @param name
 * @param props
 * @return {object}
 */
export function getInputFilterRender({
  name = 'ElInput',
  attrs = { placeholder: '选择回车筛选' }
} = {}) {
  return {
    name,
    attrs,
    nativeEvents: {
      keyup: ({ $panel }, event) => {
        if (isEnter(event)) {
          $panel.confirmFilter();
        }
      }
    }
  };
}

/**
 * @desc 一般的InputFilter的筛选方法，模糊查询
 * @param row
 * @param column
 * @param option
 * @return {boolean}
 */
export function inputFilterMethod({ row, column, option }) {
  if (!option.data) {
    return true;
  }
  let value = row[column.field];
  if (value === undefined || value === null) {
    value = '';
  }
  return value.indexOf(option.data) > -1;
}

/**
 * @desc 获取一般的InputFilter
 * @param name
 * @param props
 * @return {object}
 */
export function getSelectFilterRender({ name = 'ElSelect', options, multiple }) {
  let multipleValue = false;
  if (appUtils.isBoolean(multiple)) {
    multipleValue = multiple;
  }
  if (appUtils.isFunction(multiple)) {
    multipleValue = multiple();
  }
  return {
    name,
    props: {
      multiple: multipleValue
    },
    options
  };
}

/**
 * 获取日期时间的筛选器
 * @param format
 * @param type
 * @return {{name: string, props: {format: string, type: string}}}
 */
export const getDateFilterRender = ({format, type = 'date'} = {}) => {
  let _format = format;
  if (!format) {
    if (type === 'date' || type === 'daterange') {
      _format = appUtils.DATE_FORMAT;
    } else if (type === 'datetime' || type === 'datetimerange') {
      _format = appUtils.DATE_TIME_FORMAT;
    } else {
    }
  }
  return {
    name: 'ElDatePicker',
    props: {
      format: _format,
      type
    }
  };
};

/**
 * 获取datePick的slotEdit
 * @param name
 * @param props
 * @return {function}
 */
export function getDateSlotEdit({
  name = 'el-date-picker',
  props = { format: 'yyyy-MM-dd', type: 'date' }
} = {}) {
  return ({ row, column }, createElement) => {
    return [
      createElement('el-date-picker', {
        props,
        on: {
          change: value => {
            row[column.field] = value;
          }
        }
      })
    ];
  };
}

/**
 * 获取一般性的编辑模式下的弹窗选择
 * @param name
 * @param props
 * @param on
 * @return {object}
 */
export function getMetaSearchListSlots({
  name = 'x-meta-search-list',
  props = { searchOptionType: SINGLE_SELECT },
  on = {}
} = {}) {
  return {
    edit: getMetaSearchListSlotEdit({ name, props, on })
  };
}

/**
 * 获取search的slotEdit
 * @param name
 * @param props
 * @param on
 * @return {function}
 */
export function getMetaSearchListSlotEdit({
  name = 'x-meta-search-list',
  props = { searchOptionType: SINGLE_SELECT },
  on = {}
} = {}) {
  return ({ row, column }, createElement) => {
    return [
      createElement(name, {
        props: {
          value: row[column.field],
          searchOptionType: props.searchOptionType,
          dataCode: props.dataCode,
          rowKey: props.rowKey,
          rowName: props.rowName
        },
        on: Object.assign(
          {},
          {
            select: value => {
              row[column.field] = value;
            }
          },
          on
        )
      })
    ];
  };
}

/**
 * 校验列是否有设置，包括field或property是否有设置，是否有重复
 * @param columns 一般使用vxe-table/grid的collectColumn,这才将分组表头也一起检查
 * @param childrenProperty
 * @param key
 * @return {null|any} 返回第一个不合法的列或者null, null表示所有列都合法
 */
export function checkColumn({ columns, childrenProperty = 'children', key = 'property' }) {
  const obj = {};
  function checkColumnRecursive({ columns, childrenProperty, key }) {
    if (!Array.isArray(columns)) {
      return null;
    }
    for (const item of columns) {
      const invalidChild = checkColumnRecursive({
        columns: item[childrenProperty],
        childrenProperty,
        key
      });
      if (invalidChild) {
        return invalidChild;
      }
      const property = item[key];
      if (!property) {
        return item;
      }
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        return item;
      }
      obj[property] = item;
    }
    return null;
  }
  return checkColumnRecursive({ columns, childrenProperty, key });
}

/**
 * 格式化日期，将后面的时分秒去掉
 */
export const dateFormatter = getDateFormatter({format: DATE_FORMAT});
/**
 * 格式化日期，将后面的秒去掉
 */
export const dateTimeShortFormatter = getDateFormatter({format: DATE_TIME_SHORT_FORMAT});
/**
 * 格式化日期，精确到时分秒
 */
export const dateTimeFormatter = getDateFormatter({format: DATE_TIME_FORMAT});
/**
 * 格式化数字，保留两位小数,如果只是截取两位小数，直接引用即可
 * @param cellValue
 * @return {*}
 */
export const FLOAT_FORMATTER = getFloatFormatter({});

/**
 * 自定义格式化函数
 * @param format 格式如'0.0000'保留4位小数
 * @return {function}
 */
export function getFloatFormatter({ format }) {
  return function ({ cellValue }) {
    if (appUtils.isEmpty(cellValue)) {
      return cellValue;
    }
    return numeral(cellValue).format(format);
  };
}

/**
 * @desc 格式化数据，强制保留几位小数
 * @param cellValue
 * @param num 保留的小数位数
 * @return {string}
 */
export function changeDecimal(cellValue, num) {
  const val = parseFloat(cellValue);
  if (isNaN(val)) return cellValue;
  if (num <= 0) return parseInt(cellValue);
  const f = Math.round(cellValue * 10 * num) / (10 * num);
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + num) {
    s += '0';
  }
  return s;
}

/**
 * 改变vxe-table或者vxe-grid的列的属性， property和propertyArray需要传入其中一个
 * @param table
 * @param field 列的field字段值
 * @param property 列的属性
 * @param propertyArray 列的属性数组，根据数组的顺序，向下一级属性设置value
 * @param value
 */
export function changeColumnProperty({ table, field, property, propertyArray, value }) {
  const column = table.getColumnByField(field);
  if (property) {
    column[property] = value;
    return;
  }
  if (!Array.isArray(propertyArray) || propertyArray.length < 1) {
    return;
  }
  let obj = column;
  for (let i = 0; i < propertyArray.length - 1; i++) {
    obj = obj[propertyArray[i]];
    if (obj === undefined) {
      return;
    }
  }
  obj[propertyArray[propertyArray.length - 1]] = value;
}

/**
 * 改变vxe-table或者vxe-grid的列的属性， property和propertyArray需要传入其中一个
 * @param table
 * @param fieldArray
 * @param property
 * @param propertyArray
 * @param value
 * @param valueArray
 */
export function changeColumnPropertyBatch({
  table,
  fieldArray,
  property,
  propertyArray,
  value,
  valueArray
}) {
  for (let i = 0; i < fieldArray.length; i++) {
    if (Array.isArray(valueArray)) {
      changeColumnProperty({
        table,
        field: fieldArray[i],
        property,
        propertyArray,
        value: valueArray[i]
      });
    } else {
      changeColumnProperty({ table, field: fieldArray[i], property, propertyArray, value });
    }
  }
}

/**
 * @desc 该方法主要用于组装列缓存的key, 加上前缀和后缀是为了防止和其它缓存冲突
 * @param name 缓存的名称
 * @param prefix 前缀
 * @param suffix 后缀
 */
export function getColumnCacheName({ name, prefix = 'x-table-column-cache', suffix = '' }) {
  let columnCache = name;
  if (appUtils.isNotEmpty(prefix)) {
    columnCache = prefix + '-' + columnCache;
  }
  if (appUtils.isNotEmpty(suffix)) {
    columnCache = columnCache + '-' + suffix;
  }
  return columnCache;
}

/**
 * @desc 统计单列数据
 * @param column
 * @param rows
 * @param validate
 * @param dynamicStatistics 是不是动态统计
 * @param format 结果是否使用格式化
 * @return {*}
 */
export function countSingleColumn({
  column,
  rows,
  validate,
  dynamicStatistics = false,
  format = true
}) {
  const count = numeral(0);
  const formatter = column.formatter;
  const params = column.params;
  if (
    dynamicStatistics &&
    params &&
    params.dynamicStatisticsConfig &&
    params.dynamicStatisticsConfig.enabled === false
  ) {
    return 0;
  }
  let flag = false;
  for (const row of rows) {
    let value = row[column.field];
    // formattedData是使用格式化后的数据作为数据源统计，这种方式可以保值统计结果和列表中动手统计结果保持一致，但是会叠加误差
    if (params && params.formattedData && formatter) {
      value = formatter({ cellValue: value, row, column });
    }
    if (value === null || appUtils.isBoolean(value) || isNaN(Number(value))) {
      // 非数值暂时不抛异常
      // throw new Error('统计异常，' + (column.title || column.field) + '的值' + value + '不是数值');
      continue;
    }
    // 如果有传入validate, 就使用validate来校验
    if (validate && !validate({ column, row, value })) {
      continue;
    }
    flag = true;
    count.add(value);
  }
  // 没有进行过统计的直接返回0
  if (!flag) {
    /*
    // 这里要判断是否有formatter
    if (formatter) {
      const value = formatter({cellValue: 0, column});
      // 如果格式化的value不是一个数值（有可能是时间日期, cellValue是时间戳，但是格式化之后是字符串），就返回0
      // isNaN(null)返回的false,因此这里要多做一个判断
      if (value === null) {
        return 0;
      }
      if (!isNaN(value)) {
        return value;
      }
    }
    */
    return 0;
  }
  // 由于column的formatter不会对统计结果进行处理，因此这里需要处理一下
  // 如果传入了params.format，就使用params.format
  // 这里先注释掉，统一使用formatter来控制格式
  // if (params && params.format) {
  //   return count.format(params.format);
  // }
  const value = count.value();
  // 如果传入formatter,就使用formatter
  if (format && formatter) {
    return formatter({ cellValue: value, column });
  }
  // 直接返回数值
  return value;
}

/**
 * 获取tabPane的配置信息
 * @param tabName
 * @param name
 * @param tabConfig
 * @return {null|any}
 */
export function getTabPane({tabName, name, tabConfig }) {
  if (!Array.isArray(tabConfig.list)) {
    return null;
  }
  for (const item of tabConfig.list) {
    if (appUtils.isNotEmpty(tabName) && tabName === item.tabName) {
      return item;
    }
    if (item.name === name) {
      return item;
    }
  }
  return null;
}

/**
 * 将columns拆分成分组表头和真实表头
 * @param columns
 * @return {object}
 */
export function getGroupColumnsAndLeafColumns({ columns }) {
  const groupColumns = [];
  const leafColumns = [];
  const columnObject = {};
  const groupColumnObject = {};
  for (const item of columns) {
    columnObject[item.fieldCode] = item;
  }
  // 先找出所有的分组表头，剩下就是真实表头
  for (const item of columns) {
    const parentFieldCode = item.parentFieldCode;
    if (!parentFieldCode) {
      continue;
    }
    const groupColumn = columnObject[parentFieldCode];
    if (!groupColumn) {
      throw new RuleError(item.fieldName + '找不到对应的分组父表头' + parentFieldCode);
    }
    if (!groupColumnObject[parentFieldCode]) {
      groupColumnObject[parentFieldCode] = groupColumn;
    }
  }
  // 找真实表头
  for (const item of columns) {
    if (!groupColumnObject[item.fieldCode]) {
      leafColumns.push(item);
    }
  }
  // 重新排序，真实表头的orderValue是自然数，分组表头的orderValue是负数，第一个是-1，第二个是-2
  leafColumns.sort((firstEl, secondEl) => {
    return firstEl.orderValue - secondEl.orderValue;
  });
  for (const key in groupColumnObject) {
    groupColumns.push(groupColumnObject[key]);
  }
  groupColumns.sort((firstEl, secondEl) => {
    return secondEl.orderValue - firstEl.orderValue;
  });
  return { groupColumns, leafColumns };
}

/**
 * 获取cell的class
 * @param args vxe-table传入的参数
 * @param requiredMethod 自定义判断单元格是否必填的方法, 返回true表示必填，false表示非必填
 * @param disabledMethod 自定义判断单元格是否不可编辑, 返回true表示不可编辑，false表示可编辑
 * @param disabledClass 不能编辑的class
 * @param requiredClass 必填的class
 * @param editClass 可编辑的class
 * @param editRules 校验规则
 * @return {string[]} 返回一个class的数组
 */
export function getCellClassName(
  args,
  {
    disabledClass = 'disabled-cell',
    requiredClass = 'required-cell',
    editClass = '',
    requiredMethod: $requiredMethod,
    disabledMethod,
    editRules
  } = {}
) {
  const { column, $table } = args;
  // 整个表格都不能编辑
  const editConfig = $table.editConfig;
  if (editConfig) {
    if (editConfig.enabled === false) {
      return [disabledClass];
    }
    // 根据activeMethods判断是否可以编辑
    // 为了实现单元格局部类容可以选中，activeMethod默认返回true,所以这里先注释掉下面的三行代码
    // if (editConfig.activeMethod) {
    //   if (!editConfig.activeMethod({row, column})) {
    //     return [disabledClass];
    //   }
    // }
  }
  // 如果有requiredMethod或者disabledMethod，就使用这两个method
  if ($requiredMethod || disabledMethod) {
    if (disabledMethod && disabledMethod(args)) {
      return [disabledClass];
    }
    if ($requiredMethod && $requiredMethod(args)) {
      return [requiredClass];
    }
    return [];
  }
  if (column.editRender && column.editRender.enabled === false) {
    return [disabledClass];
  }
  if (requiredMethod(args)) {
    return [requiredClass];
  }
  return [editClass];
}

/**
 * @desc 判断是否不可编辑
 * @param column
 * @return {boolean}
 */
export function disabledMethod({ column }) {
  if (isColumnReadOnly(column)) {
    return true;
  }
  return false;
}

/**
 * @desc 判断是否必填
 * @param args
 * @return {boolean}
 */
export function requiredMethod(args) {
  const { row, column, $table } = args;
  const editRules = $table.editRules;
  if (!editRules) {
    return false;
  }
  for (const key in editRules) {
    if (key !== column.field) {
      continue;
    }
    const rules = $table.editRules[key];
    for (const rule of rules) {
      // 只要找打一个必填的就直接返回
      if (rule.required === true) {
        return true;
      }
      if (!rule.validator) {
        continue;
      }
      const result = rule.validator({ rules, rule, cellValue: row[key], ...args });
      // cell-class-name接收的是同步方法，所以如果是异步的，就跳过
      if (!result || result instanceof Promise) {
        continue;
      }
      return true;
    }
  }
  return false;
}

/**
 * @desc 判断是否有列需要统计
 * @param columns
 * @param propertyArray
 * @return {boolean}
 */
export function getStatisticsFlag({ columns, propertyArray }) {
  const list = getLeafList({ tree: columns, childrenProperty: 'children' });
  for (const item of list) {
    if (!item.params || !item.params.metaDataField) {
      continue;
    }
    const metaDataField = item.params.metaDataField;
    for (const property of propertyArray) {
      if (metaDataField[property] === true) {
        return true;
      }
    }
  }
  return false;
}

/**
 * 复制数据，且元素是原来元素JSON.stringify后的值
 * @param list
 * @return {[]}
 */
export function getStringifyItemList({ list }) {
  const newList = [];
  if (!Array.isArray(list) || list.length < 1) {
    return newList;
  }
  for (const item of list) {
    newList.push(JSON.stringify(item));
  }
  return newList;
}

/**
 * 排序数组转换，vxe-table传入的排序数组的顺序是参照列的顺序，用户希望的排序是参照点击顺序
 * @param currentSortList vxe-table通过sort-change回调传入的排序数组
 * @param lastSortList 上一次生成的排序数组
 * @return {array}
 */
export function convertSortList({ currentSortList, lastSortList }) {
  // vxe-table的生成sortList的顺序是根据column的顺序来排列的，但是用于希望的顺序是点击的顺序
  // sortList的元素是{field: '', order: '', column: {}},其中order是小写
  // 对比currentSortList和lastSortList,调整顺序
  // 1.如果currentSortList中没有但是lastSortList有，就要将lastSortList中的元素删除，因为用户清取消了该排序
  // 2.如果lastSortList没有，但是currentSortList中有的，就放入lastSortList数组的尾部
  const list = Array.isArray(lastSortList) ? [...lastSortList] : [];
  for (let i = list.length - 1; i > -1; i--) {
    const sort = list[i];
    let j = 0;
    for (; j < currentSortList.length; j++) {
      if (currentSortList[j].field === sort.field) {
        break;
      }
    }
    if (j === currentSortList.length) {
      list.splice(i, 1);
    }
  }
  for (const item of currentSortList) {
    let i = 0;
    for (; i < list.length; i++) {
      const sort = list[i];
      if (sort.field === item.field) {
        sort.order = item.order;
        break;
      }
    }
    if (i === list.length) {
      list.push(item);
    }
  }
  return list;
}

/**
 * @desc 显示表单校验失败的信息
 * @param invalidFields
 */
export function showInvalidFieldsMessage({ invalidFields }) {
  // 同时显示多个message会有遮挡的情况，将显示message放到setTimeout中
  for (const key in invalidFields) {
    for (const item of invalidFields[key]) {
      setTimeout(() => {
        let message = item.message;
        if (item.label) {
          message = item.label + '-' + message;
        }
        Notification.error(message);
      }, 0);
    }
  }
}

export function handleError(error) {
  console.log('handleError开始');
  if (error === undefined || error === null) {
    // warningConfirm组件和request.js可能传入一个undefined的error
    return;
  }
  console.error('handleError', error);
  console.log('handleError2', JSON.stringify(error));
  if (error.$selfHandle) {
    throw error;
  }
  if (error instanceof NonsenseError) {
    return;
  }
  if (error instanceof RuleError) {
    if (error.invalidFields) {
      showInvalidFieldsMessage({ invalidFields: error.invalidFields });
      return;
    }
    Notification.error(error.message);
    return;
  }
  if (error instanceof RequestError) {
    Notification.error(error.message);
    throw error;
  }
  if (appUtils.isBoolean(error)) {
    // 这种有可能是el-form reject的错误
    Notification.error('请正确填写表单');
    return;
  }
  if (appUtils.isString(error)) {
    if (error === 'cancel') {
      // $confirm点击取消，不用处理
      return;
    }
    Notification.error(error);
    return;
  }
  // 有可能是vxe-table的错误
  if (appUtils.isPlainObject(error)) {
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    if (hasOwnProperty.call(error, 'code') && hasOwnProperty.call(error, 'success')) {
      Notification.error(error.message || error.msg);
      return;
    }
    for (const key in error) {
      const { rowIndex, rule } = error[key][0];
      Notification.error(`第${rowIndex + 1}行，${rule.message}`);
      break;
    }
    return;
  }
  if (error.$showToUser !== true) {
    Notification.error(error.message || '系统异常，请稍后重试！');
    console.log('colno', error.colno);
    console.log('error.error', error.error);
    console.log('filename', error.filename);
    console.log('lineno', error.lineno);
    console.log('message', error.message);
    console.log('type', error.type);
    console.log('target', error.target);
    // 避免重复弹出错误提示
    error.$showToUser = true;
  }
  throw error;
}

/**
 * 设置element的tabindex让element可以获取焦点
 * @param element
 * @param value
 */
export function setTabindex({ element, value = 0 } = {}) {
  const name = 'tabindex';
  const attribute = element.getAttribute(name);
  if (attribute === null || attribute === '') {
    element.setAttribute(name, value);
  }
  // 如果已经有attribute就暂时不去改动
  return element;
}

/**
 * 判断单元格是否可以编辑
 * @param $grid
 * @param $table
 * @param row
 * @param column
 */
export function isEditable({ $grid, $table, row, column }) {
  const tableInstance = $grid || $table;
  const editConfig = tableInstance.editConfig || {};
  // 参考 node_modules/vxe-table/packages/edit/src/mixin.js  handleActived
  // 先判断editConfig, 再判断editRender，最后判断activeMethod
  if (editConfig.enabled === false) {
    return false;
  }
  const editRender = column.editRender || {};
  if (editRender.enabled === false) {
    return false;
  }
  // 部分单元格为了实现可以选中单元格内的部分文字，而是使用编辑模式，这些单元格也不能编辑
  if (isColumnReadOnly(column)) {
    return false;
  }
  // 有时候开发人员会通过editRender.enabled = true来表示该单元格的值可以修改（如通过点击单元格弹出弹窗，但是单元格本身没有编辑模式）
  // 这种情况下需要返回true
  // if (editRender.enabled === true) {
  //   return true;
  // }
  if (editConfig.activeMethod && !editConfig.activeMethod({ row, column })) {
    return false;
  }
  // node_modules/vxe-table/packages/tools/src/utils.js
  // 源码中只要不是false，都是可编辑，因此还需要判断name和slots.edit
  // export function isEnableConf (conf) {
  //   return conf && conf.enabled !== false
  // }
  // 因为editRender.enabled默认是true,如果开发人元没有设置这个值，就需要再根据name和slots.edit来判断了
  const slots = column.slots;
  if (!editRender.name && (!slots || !slots.edit)) {
    return false;
  }
  return true;
}

/**
 * 创建一行新纪录，vxe-table源码是根据visibleColumn来创建的，可能会有问题，这里改为根据fullColumn来创建
 * @param $grid
 * @param $table
 * @return {{}}
 */
export function createRow({ $grid, $table }) {
  const row = {};
  const tableInstance = $grid || $table;
  const fullColumn = tableInstance.getTableColumn().fullColumn;
  for (const column of fullColumn) {
    if (column.type) {
      continue;
    }
    const property = column.field;
    if (
      column.editRender &&
      Object.prototype.hasOwnProperty.call(column.editRender, 'defaultValue')
    ) {
      const defaultValue = column.editRender.defaultValue;
      if (appUtils.isFunction(defaultValue)) {
        row[property] = column.editRender.defaultValue({ column });
      } else {
        row[property] = column.editRender.defaultValue;
      }
      continue;
    }
    row[property] = null;
  }
  return row;
}

/**
 * 在表格后面追加数据
 * @param args
 * @return {*|void|Promise<void>}
 */
export function appendRow(args) {
  const { rows, $grid, $table } = args;
  const tableInstance = $grid || $table;
  if (Array.isArray(tableInstance.$options.propsData.data)) {
    tableInstance.$options.propsData.data.push(...rows);
    return tableInstance.$nextTick().then(() => {
      return args;
    });
  } else {
    return tableInstance.insertAt(rows, -1).then(() => {
      return args;
    });
  }
}

/**
 * @desc 通用的filter
 * @param option
 */
export function filterRecoverMethod({ option }) {
  if (appUtils.isString(option.data)) {
    option.data = '';
  } else if (Array.isArray(option.data)) {
    option.data = [];
  } else {
    option.data = null;
  }
}

/**
 * 完善column的信息
 * @param columns
 * @param sortable
 */
export function enhanceColumns({ columns, sortable = false }) {
  if (!Array.isArray(columns)) {
    return;
  }
  for (const item of columns) {
    // 默认增加sortable
    if (
      (!Array.isArray(item.children) || item.children.length < 1) &&
      !Object.prototype.hasOwnProperty.call(item, 'sortable') &&
      item.type !== 'radio' &&
      item.type !== 'checkbox' &&
      item.type !== 'seq' &&
      item.type !== 'expand' &&
      item.type !== 'html'
    ) {
      item.sortable = sortable;
    }
    if (Array.isArray(item.children)) {
      enhanceColumns({ columns: item.children, sortable });
    }
    // if (!item.filterRecoverMethod) {
    //   item.filterRecoverMethod = filterRecoverMethod;
    // }
  }
}

/**
 * 递归初始化column的params属性，因为开发人员会多个columns使用同一个params,导致排序的数字有问题
 * @param columns
 */
export function initColumnParams({ columns }) {
  if (!Array.isArray(columns)) {
    return;
  }
  for (const item of columns) {
    if (item.params) {
      item.params = Object.assign({}, item.params);
    } else {
      item.params = {};
    }
    initColumnParams({ columns: item.children });
  }
}

/**
 * 激活下一个可编辑单元格
 * @param $grid
 * @param $table
 * @param row 如果传入了row和column就能定位表格中的某个单元格，此时会从该单元格开始找下一个可以激活的单元格，
 * 如果没有传入row和column就会冲当前激活单元格开始查找一个可以编辑单元格
 * @param column
 * @param disabledMethod 判断单元格th是否可以编辑的方法, 默认return false;
 * @param propertyArray 下一个而被激活的单元格的数组，[{from: 'key1', to: 'key2'}],from表示当前的单元格字段，to表示下一个单元格的字段，如果
 * 如果from和to相同，就会激活同列的下一行单元格，如果不相同，就激活同一行to对应的单元格
 * @param propertyMethod 获取下一个被激活的单元格的方法, 如果同时传入propertyMethod和propertyArray, propertyArray会失效
 * 如果propertyMethod返回的值和传入的column一行，就激活同列的下一行单元格，如果不相同，就激活同一行to对应的单元格
 */
export function activeNextCell({
  $grid,
  $table,
  row,
  column,
  disabledMethod = () => {
    return false;
  },
  propertyArray,
  propertyMethod
}) {
  const promise = new Promise(() => {});
  const tableInstance = $grid || $table;
  let activeColumn;
  let activeRow;
  if (!row || !column) {
    const activeRecord = tableInstance.getActiveRecord();
    // 如果editConfig.isEnter是true,activeRecord有可能是null
    if (!activeRecord) {
      return promise;
    }
    activeColumn = activeRecord.column;
    activeRow = activeRecord.row;
  } else {
    activeColumn = column;
    activeRow = row;
  }
  const editConfig = tableInstance.editConfig;
  if (editConfig.enabled === false) {
    return promise;
  }
  const visibleData = tableInstance.getTableData().visibleData;
  const visibleColumn = tableInstance.getTableColumn().visibleColumn;
  let nextColumn = null;
  let nextProperty = '';
  const nextRow = visibleData[visibleData.indexOf(activeRow) + 1];
  // 根据propertyMethod来获取下一个可以激活的单元格
  if (propertyMethod) {
    nextProperty = propertyMethod({ column: activeColumn, row: activeRow });
    // 激活下一行同列单元格
    if (nextProperty === activeColumn.field) {
      if (!nextRow) {
        return promise;
      }
      // 通过disabledMethod判断单元格是否可以编辑
      if (!disabledMethod({ row: nextRow, column: activeColumn })) {
        return tableInstance.setActiveCell(nextRow, activeColumn);
      }
    }
    // 在同一行中查找对应的column
    for (const item of visibleColumn) {
      if (item.field === nextProperty) {
        nextColumn = item;
        break;
      }
    }
    if (nextColumn && !disabledMethod({ row: activeRow, column: nextColumn })) {
      return tableInstance.setActiveCell(activeRow, nextColumn);
    }
  }
  // 根据propertyArray来获取下一个可编辑单元格
  if (Array.isArray(propertyArray) && propertyArray.length > 0) {
    for (const item of propertyArray) {
      if (item.from === activeColumn.field) {
        nextProperty = item.to;
        break;
      }
    }
    // 激活同列的下一行
    if (activeColumn.field === nextProperty) {
      if (nextRow && !disabledMethod({ row: nextRow, column: activeColumn })) {
        return tableInstance.setActiveCell(nextRow, activeColumn);
      }
      return promise;
    }
    // 在同一行中查找对应的column
    for (const item of visibleColumn) {
      if (item.field === nextProperty) {
        nextColumn = item;
        break;
      }
    }
    if (nextColumn && !disabledMethod({ row: activeRow, column: nextColumn })) {
      return tableInstance.setActiveCell(activeRow, nextColumn);
    }
  }
  // 如果通过propertyMethod和propertyArray都找不到nextColumn，就执行下面逻辑
  // 找出当前列和当前列的下一个编辑列
  let currentColumn;
  let i;
  const activeMethod = editConfig.activeMethod;
  for (i = 0; i < visibleColumn.length; i++) {
    const item = visibleColumn[i];
    // 不可编辑列，跳过本次循环
    if (activeMethod && !activeMethod({ row: activeRow, column: item })) {
      continue;
    }
    if (disabledMethod({ row: activeRow, column: item })) {
      continue;
    }
    if (isColumnReadOnly(item)) {
      continue;
    }
    // 找出当前列并将下一个可编辑列也和当前列指向同一个对象
    if (activeColumn.field === item.field) {
      currentColumn = item;
      nextColumn = item;
    }
    // 当前的下一个列赋值给nextColumn，同时结束本次循环
    if (nextColumn && nextColumn !== item) {
      nextColumn = item;
      break;
    }
  }
  // 当前列和下一个列不是同一个对象，直接激活下一个可编辑框
  if (currentColumn !== nextColumn) {
    return tableInstance.setActiveCell(activeRow, nextColumn);
  }
  // 找出下面行第一个可以编辑的列
  for (let i = visibleData.indexOf(activeRow) + 1; i < visibleData.length; i++) {
    const nextRow = visibleData[visibleData.indexOf(activeRow) + 1];
    if (!nextRow) {
      return promise;
    }
    for (i = 0; i < visibleColumn.length; i++) {
      const item = visibleColumn[i];
      // 不可编辑列，跳过本次循环
      if (activeMethod && !activeMethod({ row: nextRow, column: item })) {
        continue;
      }
      if (isColumnReadOnly(item)) {
        continue;
      }
      if (disabledMethod({ row: nextRow, column: item })) {
        continue;
      }
      // 第一个可编辑的列
      return tableInstance.setActiveCell(nextRow, item);
    }
  }
  return promise;
}

/**
 * 激活第一个可编辑的单元格
 * @param $grid
 * @param $table
 * @param row
 */
export function activeFirstCell({ $grid, $table, row }) {
  const tableInstance = $grid || $table;
  const editConfig = tableInstance.editConfig;
  if (editConfig.enabled === false) {
    return;
  }
  const visibleColumn = tableInstance.getTableColumn().visibleColumn;
  const activeMethod = editConfig.activeMethod;
  for (let i = 0; i < visibleColumn.length; i++) {
    const column = visibleColumn[i];
    const type = column.type;
    if (
      type === 'checkbox' ||
      type === 'seq' ||
      type === 'radio' ||
      type === 'expand' ||
      type === 'html'
    ) {
      continue;
    }
    // 不可编辑列，跳过本次循环
    if (isColumnReadOnly(column)) {
      continue;
    }
    if (activeMethod && !activeMethod({ row, column })) {
      continue;
    }
    // 第一个可编辑的列
    tableInstance.setActiveCell(row, column);
    return;
  }
}

/**
 * 获取模拟编辑的内容
 * @param args
 * @param createElement
 * @param on
 * @return {*[]}
 */
export function getFakeEditContent(args, createElement, { on } = {}) {
  const { row, column } = args;
  let content = row[column.field];
  if (column.formatter) {
    content = column.formatter({ row, column, cellValue: content });
  }
  const attribute = {
    class: {
      'vxe-cell--label': true,
      'fake-edit-content': true
    },
    attrs: {
      // 设置tabindex，使div可以获取焦点，因为部分浏览器上某些页面
      // 在table-operate-mixin.js的handleMouseDownCapture方法，setActiveCell又回自动
      // 变回默认模式
      tabindex: '0'
    },
    on: {
      blur: event => {
        event.target.parentElement.scrollLeft = 0;
      }
    }
  };
  if (on) {
    Object.assign(attribute.on, on);
  }
  return [createElement('span', attribute, content)];
}

/**
 * 判断是列是否只读
 * @param column
 * @return {boolean}
 */
export function isColumnReadOnly(column) {
  if (column.params && column.params.metaQueryList && column.params.metaQueryList.readOnly) {
    return true;
  }
  return false;
}

/**
 * 根据event.target来获取事件对应的component,这个方法主要是用于多个component的$el绑定同一个事件会用到
 * @param event
 * @param components
 * @return {null|any}
 */
export function getComponentByEvent({ event, components }) {
  for (const item of components) {
    if (event.target === item.$el) {
      return item;
    }
  }
  return null;
}

/**
 * 转换queryParams,主要用于list-page，multiple-tab-list-page等页面
 * @param conditionConfig
 * @param tabConfig
 * @param queryParams
 * @param filterList
 * @param sortList
 */
export function convertQueryParams({
  conditionConfig,
  tabConfig,
  queryParams,
  filterList,
  sortList
}) {
  if (tabConfig) {
    if (tabConfig.handleQueryParams) {
      tabConfig.handleQueryParams({ tabConfig, queryParams });
    } else {
      if (tabConfig.field) {
        queryParams[tabConfig.field] = tabConfig.activeName;
      }
    }
  }
  const model = conditionConfig.model;
  const list = conditionConfig.list;
  if (model && Array.isArray(list)) {
    for (const item of list) {
      if (item.toQuery === false) {
        continue;
      }
      const field = item.field;
      const value = model[field];
      // if (value === undefined || value === null || value === '') {
      //   continue;
      // }
      switch (item.type) {
        case FIELD_TYPE_INPUT:
        case FIELD_TYPE_SELECT:
        case FIELD_TYPE_DATE:
        case FIELD_TYPE_MONTH:
        case FIELD_TYPE_DATETIME:
        case FIELD_TYPE_RADIO:
        case FIELD_TYPE_CHECKBOX:
          queryParams[item.field] = value;
          break;
        case FIELD_TYPE_MULTIPLE_SELECT:
        case FIELD_TYPE_CASCADER:
        case FIELD_TYPE_CHECKBOX_GROUP:
          queryParams[item.field] = Array.isArray(value) ? value.join(',') : value;
          break;
        case FIELD_TYPE_DATERANGE:
        case FIELD_TYPE_DATETIME_RANGE:
        case FIELD_TYPE_TIME_RANGE:
          if (!Array.isArray(value)) {
            delete queryParams['start' + appUtils.capitalizeFirstLetter(field)];
            delete queryParams['end' + appUtils.capitalizeFirstLetter(field)];
            break;
          }
          queryParams['start' + appUtils.capitalizeFirstLetter(field)] = value[0];
          queryParams['end' + appUtils.capitalizeFirstLetter(field)] = value[1];
          break;
        case FIELD_TYPE_POP_MULTI:
        case FIELD_TYPE_LIST_POP_MULTI:
          if (Array.isArray(value)) {
            if (item.fromArray) {
              queryParams[field] = item.fromArray({ source: value, rowKey: item.rowKey });
            } else {
              queryParams[field] = appUtils.fromArrayToCommaDivideString({
                source: value,
                rowKey: item.rowKey
              });
            }
          } else {
            queryParams[field] = value;
          }
          break;
        case FIELD_TYPE_POP_ONE:
        case FIELD_TYPE_LIST_POP_ONE:
          if (appUtils.isObject(value)) {
            queryParams[field] = value[item.rowKey];
          } else {
            queryParams[field] = value;
          }
          break;
        default:
          break;
      }
    }
  }
  if (Array.isArray(filterList)) {
    for (const item of filterList) {
      const params = item.column.params;
      const property = item.column.field;
      const values = item.values;
      if (values[0]) {
        // checkbox选择
        // :filters="[{ label: '包含 6', value: '6' }, { label: '包含 4', value: '4' }]"
        queryParams[property] = values.join(',');
      } else {
        const data = item.datas[0];
        if (Array.isArray(data)) {
          // 下拉多选和弹窗多选的情况
          // 判断每个元素是对象还是基础数据类型
          const firstDataItem = data[0];
          if (
            appUtils.isString(firstDataItem) ||
            appUtils.isBoolean(firstDataItem) ||
            appUtils.isNumber(firstDataItem)
          ) {
            queryParams[property] = data.join(',');
          } else {
            const arr = [];
            for (const dataItem of data) {
              arr.push(dataItem[params.rowKey]);
            }
            queryParams[property] = arr.join(',');
          }
        } else {
          if (appUtils.isString(data)) {
            if (data.trim()) {
              queryParams[property] = data.trim();
            }
          } else if (data instanceof Date) {
            queryParams[property] = data.getTime();
          } else {
            queryParams[property] = data;
          }
        }
      }
    }
  }
  if (Array.isArray(sortList) && sortList.length > 0) {
    queryParams.sortParam = getSortString({ sortList });
  }
}

/**
 * 将vxe-table的sortList转成接口的sort字符串
 * @param sortList
 * @return {string}
 */
export function getSortString({ sortList }) {
  const list = [];
  for (const item of sortList) {
    list.push({ columnName: item.field, order: item.order.toLowerCase() });
  }
  return JSON.stringify(list);
}

/**
 * @desc 设置表头显示的排序数字
 * @param sortList
 * @param clear 是否清空，如果是true,就是删除sortNumber，默认是false
 */
export function setSortNumber({ sortList, clear = false }) {
  for (let i = 0; i < sortList.length; i++) {
    const item = sortList[i].column;
    if (clear) {
      if (item.params) {
        delete item.params.sortNumber;
      }
      continue;
    }
    if (!item.params) {
      item.params = {};
    }
    item.params.sortNumber = i + 1;
  }
}

export function initCloumnHeaderSort(columns) {
  for (const item of columns) {
    if (Array.isArray(item.children) && item.children.length > 0) {
      initCloumnHeaderSort(item.children);
      continue;
    }
    if (item.sortable !== true) {
      continue;
    }
    if (!item.slots) {
      item.slots = {};
    }
    if (item.slots.header) {
      continue;
    }
    item.slots.header = ({ column, $table }, createElement) => {
      const params = column.params;
      const sortConfig = $table.sortConfig || {};
      if (!params || !params.sortNumber || sortConfig.multiple !== true) {
        return [createElement('span', {}, column.title)];
      }
      return [
        createElement('span', {}, column.title),
        createElement('span', { class: 'table-header-sort-number' }, params.sortNumber)
      ];
    };
  }
}

/**
 * 判断url对应的文件是不是一个图片
 * @param url
 * @return {boolean}
 */
export function isImage({ url }) {
  const lowerCaseUrl = url.toLowerCase();
  return (
    lowerCaseUrl.indexOf('.png') > -1 ||
    lowerCaseUrl.indexOf('.jpg') > -1 ||
    lowerCaseUrl.indexOf('.jpeg') > -1 ||
    lowerCaseUrl.indexOf('.gif') > -1 ||
    lowerCaseUrl.indexOf('.bmp') > -1 ||
    lowerCaseUrl.indexOf('.tiff') > -1 ||
    lowerCaseUrl.indexOf('.tif') > -1
  );
}

/**
 * 预览或下载文件
 * @param file
 * @param uploadFiles
 * @param previewMode 预览模式， 如['pdf'],就支持pdf预览
 */
export async function previewFile({ file, uploadFiles, previewMode = [] }) {
  let url = file.raw ? file.response.data.url : file.url;
  const lowerCaseUrl = url.toLowerCase();
  if (isImage({ url })) {
    let images = [];
    let initialViewIndex = 0;
    for (const item of uploadFiles) {
      url = item.raw ? item.response.data.url : item.url;
      if (!isImage({ url })) {
        continue;
      }
      images.push(url);
      const fileUrl = file.raw ? file.response.data.url : file.url;
      if (url === fileUrl) {
        initialViewIndex = images.indexOf(url);
      }
    }
    for (let i = 0; i < images.length; i++) {
      // 如果是以//开头，就加上http或者https
      if (images[i].startsWith('//')) {
        images[i] = window.location.protocol + images[i];
      }
    }
    // images = await Promise.all(images.map(async url => await createFileUrl({ url, only })));
    viewerApi({
      options: {
        initialViewIndex
      },
      images
    });
    return;
  }
  // if (previewMode.includes('office')) {
  //   if (lowerCaseUrl.indexOf('.doc') > -1 || lowerCaseUrl.indexOf('.ppt') > -1 || lowerCaseUrl.indexOf('.xls') > -1) {
  //     window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url));
  //     return;
  //   }
  // }
  if (previewMode.includes('pdf')) {
    if (lowerCaseUrl.indexOf('.pdf') > -1) {
      window.open(url);
      return;
    }
  }
  let fileName = file.fileName || file.name;
  if (!fileName) {
    fileName = url.substring(url.lastIndexOf('/') + 1);
  }
  // url = await createFileUrl({ url, only });
  downloadFile(url, fileName);
}

/**
 * 获取thumbnail
 * @param file 文件对象，需要包含url属性，如果是原始文件，还必须包含raw属性
 * @return {string|*}
 */
export function getFileThumbnail({ file }) {
  // 由于回显时,有可能只有url,因此通过url的后缀来判断
  let url = file.url;
  if (file.raw) {
    // 原始文件的url不包含文件名信息
    url = file.name;
  }
  url = url.toLowerCase();
  if (url.indexOf('.pdf') > -1) {
    return PDF_ICON;
  }
  if (url.indexOf('.ppt') > -1) {
    return PPT_ICON;
  }
  if (url.indexOf('.xls') > -1 || url.indexOf('.csv') > -1) {
    return EXCEL_ICON;
  }
  if (url.indexOf('.doc') > -1) {
    return WORD_ICON;
  }
  if (url.indexOf('.zip') > -1 || url.indexOf('.rar') > -1) {
    return ZIP_ICON;
  }
  if (url.indexOf('.txt') > -1) {
    return TXT_ICON;
  }
  if (url.indexOf('.apk') > -1) {
    return APK;
  }
  // 如果是图片以外的，就显示未知缩略图
  if (
    url.indexOf('.png') < 0 &&
    url.indexOf('.jpg') < 0 &&
    url.indexOf('.jpeg') < 0 &&
    url.indexOf('bmp') < 0 &&
    url.indexOf('tif') < 0
  ) {
    return UNKNOWN_FILE_ICON;
  }
  /*if (isCreateFileUrl && file.url.indexOf('blob:') === -1) {
    return createFileUrl({ url: file.url, only });
  } else {
    return file.url;
  }*/
  return file.url;
}

/**
 * 获取el-button的类型
 * @param item
 * @return {string|*}
 */
export function getButtonType({ item }) {
  if (Object.hasOwnProperty.call(item, 'type')) {
    return item.type;
  } else {
    return 'primary';
  }
}

/**
 * 上传前校验文件类型
 * @param file
 * @param accept 接受上传的文件类型，逗号分隔的字符串
 * @return {{valid: boolean}|{valid: boolean, message: string}}
 */
export function beforeUploadCheckType({ file, accept }) {
  if (!accept) {
    return { valid: true };
  }
  const arr = file.name.split('.');
  const suffix = arr[arr.length - 1].toLowerCase();
  const uploadFileType = [];
  const acceptArr = accept.split(',');
  for (const acceptItem of acceptArr) {
    uploadFileType.push(acceptItem.split('.')[1]);
  }
  if (uploadFileType.indexOf(suffix) < 0) {
    return { valid: false, message: `只能上传${uploadFileType.join(',')}格式的文件` };
  }
  return { valid: true };
}

/**
 * 获取mis_field_show_setting表的配置
 * @param dataCode
 * @return {Promise<{}>}
 */
/*export async function getMisFieldSetting({ dataCode }) {
  const response = await getByMenucode({ datacode: dataCode });
  const res = response.data;
  const fieldSetting = {};
  // 由于后端接口没有result封装，且没有查询到数据的情况下，返回null，在gateway的ModifyResponseFilter中转成空字符串，所以这里要先判断res
  if (!res) {
    return fieldSetting;
  }
  if (!res.isSuccess()) {
    throw new RequestError(res.msg);
  }
  const roleMap = res.data;
  if (!roleMap) {
    return fieldSetting;
  }
  for (const key in roleMap) {
    for (const item of roleMap[key]) {
      fieldSetting[item.field.toLowerCase()] = item;
    }
  }
  return fieldSetting;
}*/

/**
 * 根据mis_field_show_setting表的配置来设置表单项的是否隐藏
 * @param conditionList
 * @param fieldSetting
 * @return {*}
 */
export function getVisibleConditionList({ conditionList, fieldSetting }) {
  if (!Array.isArray(conditionList) || !fieldSetting) {
    return conditionList;
  }
  for (const item of conditionList) {
    const setting = fieldSetting[item.fieldCode.toLowerCase()];
    if (!setting) {
      continue;
    }
    if (!setting.visible) {
      item.show = false;
    }
  }
  return conditionList;
}

/**
 * 计算可显示的字段
 * @param fieldSetting
 * @param fields 需要控制的列表，可以是columns，也可是conditionConfig.list
 * @param {string} type  可选 如果fields传入的columns, type选择showongrid， 否则选择visible
 * @return {*}
 */
export function getVisibleFields({ fieldSetting, fields, type = 'showongrid' }) {
  if (!Array.isArray(fields) || !fieldSetting) return fields;
  let isChange = false;
  const getItem = function (list) {
    return list.filter(n => {
      if (n.children) {
        const children = getItem(n.children);
        if (n.children.length !== children.length) {
          isChange = true;
        }
        if (children.length < 1) {
          return false;
        }
        n.children = children;
      }
      const fieldName = n.field.toLowerCase();
      return !fieldSetting[fieldName] || !!fieldSetting[fieldName][type];
    });
  };
  const items = getItem(fields);
  if (items.length !== fields.length) {
    isChange = true;
  }
  return isChange ? items : fields;
}

/**
 * 初始化model
 * @param model
 * @param list
 * @param reset 是否对model已有的值进行重置，默认false
 */
export function initModel({ model, list, reset = false }) {
  const hasOwnProperty = Object.prototype.hasOwnProperty;
  for (const item of list) {
    const field = item.field;
    if (!reset && hasOwnProperty.call(model, field)) {
      continue;
    }
    // 通过函数动态赋值
    if (hasOwnProperty.call(item, 'valueMethod')) {
      Vue.set(model, field, item.valueMethod({list, model, item, reset}));
      continue;
    }
    if (hasOwnProperty.call(item, 'value')) {
      Vue.set(model, field, item.value);
      continue;
    }
    let value = '';
    switch (item.type) {
      case FIELD_TYPE_EMPTY:
        continue;
      case FIELD_TYPE_CHECKBOX:
        if (hasOwnProperty.call(item, 'falseLabel')) {
          value = item.falseLabel;
        } else {
          value = false;
        }
        break;
      case FIELD_TYPE_POP_ONE:
      case FIELD_TYPE_DATE:
      case FIELD_TYPE_DATETIME:
      case FIELD_TYPE_YEAR:
      case FIELD_TYPE_MONTH:
      case FIELD_TYPE_LIST_POP_ONE:
        value = null;
        break;
      case FIELD_TYPE_DATERANGE:
      case FIELD_TYPE_DATETIME_RANGE:
      case FIELD_TYPE_POP_MULTI:
      case FIELD_TYPE_MULTIPLE_SELECT:
      case FIELD_TYPE_CASCADER:
      case FIELD_TYPE_FILE:
      case FIELD_TYPE_LIST_POP_MULTI:
      case FIELD_TYPE_CHECKBOX_GROUP:
        value = [];
        break;
      case FIELD_TYPE_SWITCH:
        if (hasOwnProperty.call(item, 'inactiveValue')) {
          value = item.inactiveValue;
        }
        break;
      default:
        break;
    }
    Vue.set(model, field, value);
  }
  return model;
}

/**
 * 字典列格式化函数
 * @param cellValue
 * @param column
 * @return {*}
 */
export function dictFormatter({ cellValue, column }) {
  if (appUtils.isEmpty(cellValue)) {
    return cellValue;
  }
  return column.params.dict[cellValue] || cellValue;
}

/**
 * 基于label和value的格式化函数
 * @param options
 * @return {(function({cellValue: *, column: *}): (undefined|*))|*}
 */
export const getOptionFormatter = ({options} = {}) => {
  return ({cellValue, column}) => {
    let $options = options;
    if (!Array.isArray(options) && column.params) {
       $options = column.params.options;
    }
    if (!Array.isArray($options)) {
      return cellValue;
    }
    for (const item of $options) {
      if (item.value === cellValue) {
        return item.label;
      }
    }
    return cellValue;
  };
};
/**
 * 根据value获取label
 * @param options
 * @param value
 * @return {*}
 */
export const getOptionLabel = ({options, value}) => {
  if (isEmpty(options)) {
    return value;
  }
  if (!Array.isArray(options)) {
    // options为对象,key是value, value是label
    return options[value] || value;
  }
  for (const option of options) {
    if (option.value === value) {
      return option.label;
    }
  }
  return value;
}

/**
 * 根据属性名，获取属性值
 */
export const getPropertyVal = (value, option = {}) => {
  if (typeof value === 'function') {
    return value(option);
  }
  return value;
};

/**
 * 截取数字
 * @param value 数据
 * @param decimal 保留几位小数
 * @param int
 * @param minus 是否负数
 */
export const interceptNumber = ({ value, decimal, int, minus = false }) => {
  const decimalLen = decimal === undefined ? '*' : `{0,${decimal}}`;
  const intLen = int === undefined ? '*' : `{0,${int}}`;
  const regExp = new RegExp(`^\\D*(\\d${intLen}(?:\\.\\d${decimalLen})?).*$`, 'g');
  if (value !== '') {
    value = String(value);
    const n = value.charAt(0);
    value = value.replace(regExp, '$1');
    if (n === '-' && minus) {
      value = n + value;
    }
    return value;
  }
  return value;
};

export const isUndef = value => {
  return value === undefined;
};

export const sleep = time => {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
};

/**
 * 显示提示弹窗
 * @param title 标题
 * @param label 文字说明
 * @param required 是否必填
 * @param showConfirmButton 是否显示取消按钮
 * @param showConfirmButton 是否显示确定按钮
 * @param cancelButtonText 取消按钮的文字
 * @param confirmButtonText 确认按钮的文字
 * @param cancel 取消按钮的回调函数
 * @param confirm 确认按钮的回调函数
 * @return Promise
 */
export const showPrompt = async ({title, label, required = false ,showCancelButton = true, showConfirmButton = true, cancelButtonText = '取消', confirmButtonText = '确定', cancel, confirm}) => {
  let resolveFn = null;
  let rejectFn = null;
  const promise = new Promise((resolve, reject) => {
    resolveFn = resolve;
    rejectFn = reject;
  });
  const cancelFn = (arg) => {
    if (cancel) {
      cancel(arg);
    }
    rejectFn(new NonsenseError('cancel'));
    vm.$destroy();
  };
  const confirmFn = (arg) => {
    if (confirm) {
      confirm(arg);
    }
    resolveFn(arg);
    vm.$destroy();
  };
  let flag = false;
  const vm = new PromptDialogConstructor({
    el: document.createElement('div'),
    propsData: {
      label,
      title,
      showCancelButton,
      showConfirmButton,
      cancelButtonText,
      confirmButtonText,
      cancel: cancelFn,
      confirm: confirmFn,
      visible: true,
      required
    }
  });
  return promise;
};

/**
 * 表格上传附件的渲染函数
 * @param size
 * @param accept
 * @param disabled
 * @param limit
 * @param objectConverter
 * @param convertUploadFiles
 * @param data 上传文件接口，除文件以外的其它参数
 * @param tip
 * @param remoteUploadUrl
 * @param action
 * @param queryUrl
 * @param showFileName
 * @param topTip 顶部的提示
 * @return {function(*, *): [undefined]}
 */
export const uploadColumnRender = ({size, accept, disabled, limit, objectConverter, convertUploadFiles, data, tip, remoteUploadUrl, action, queryUrl, showFileName, topTip} = {}) => {
  return (args, createElement) => {
    const {row, column, $table} = args;
    const cellValue = row[column.field];
    let arr;
    if (isEmpty(cellValue)) {
      arr = [];
    } else if (isString(cellValue)){
      arr = cellValue.split(',');
    } else {
      arr = cellValue;
    }
    const fileList = arr.map((item) => { return {id: item}; });
    let text = disabled? '查看' : '选择';
    // if (fileList.length > 0) {
    //   text += `(${fileList.length})`;
    // }
    return [
      createElement('span', {
        class: 'cell-attachment-text',
        on: {
          click: () => {
            const Wrapper = Vue.extend({
              name: 'XUploadDialogWrapper',
              data() {
                return {
                  visible: false
                };
              },
              render (createElement) {
                if (!this.visible) {
                  return null;
                }
                const children = [];
                if (topTip) {
                  children.push(createElement('div', {slot: 'topTip', domProps: {innerHTML: topTip}}));
                }
                return createElement(XUploadDialog, {
                  attrs: {
                    fileList,
                    tip,
                    visible: true,
                    remoteUploadUrl,
                    action,
                    queryUrl,
                    disabled,
                    limit,
                    objectConverter,
                    size,
                    accept,
                    data,
                    showFileName,
                    convertUploadFiles: (args) => {
                      if (convertUploadFiles) {
                        // 加上row和column，方便回调函数操作
                        args.row = row;
                        args.column = column;
                        convertUploadFiles(args);
                        return;
                      }
                      const {uploadFiles} = args;
                      // 默认转换成一个url数组
                      const arr = [];
                      for (const uploadFile of uploadFiles) {
                        // 同时上传多张图片，uploadFile.response可能为空，因为有些图片未上传完成
                        if (uploadFile.response) {
                          // 当前上传的图片
                          arr.push(uploadFile.response.data.id);
                        } else {
                          // 通过fileList传入的图片
                          arr.push(uploadFile.id);
                        }
                      }
                      row[column.field] = arr;
                    }
                  },
                  on: {
                    'update:visible': (args) => {
                      if (args === false) {
                        wrapper.$destroy();
                      }
                    }
                  }
                }, children);
              }
            });
            const wrapper = new Wrapper({
              el: document.createElement('div'),
              parent: $table.$root
            });
            setTimeout(() => {
              wrapper.visible = true;
            }, 100);
          }
        }
      }, [createElement('span', {}, text), createElement('span', {class: 'x-upload-dialog-file-list-length'}, '(' + fileList.length + ')')])
    ];
  };
};

/**
 * 获取切换上一单和下一单的方法
 * @param storageKey 缓存在本地的key
 * @param path 跳转的路径
 * @param routeType 路由数据的传输方式， 如query和params 默认是params
 * @param key 数据的唯一键，默认是id
 * @param query 除了key以外的其它参数
 * @return {(function(*): void)|*}
 */
export const getSwitchOrderFn = ({storageKey, path, routeType = ROUTE_TYPE_PARAMS, key = 'id', query}) => {
  return function (type) {
    const id = this.$admin.getTabRoute(this)[routeType][key];
    const idArr = get(storageKey);
    const index = idArr.findIndex(item => id + '' === item + '');
    let _id;
    if (type === 'last') {
      _id = idArr[index - 1];
    } else {
      _id = idArr[index + 1];
    }
    let url;
    if (routeType === 'params') {
      url = path + _id;
    } else {
      url = path;
      if (url.indexOf('?') > -1) {
        if (!url.endsWith('?')) {
          url += '&';
        }
      } else {
        url += '?';
      }
      url += key + '=' + _id;
    }
    if (query) {
      const queryStr = stringify(query);
      if (appUtils.isNotEmpty(queryStr)) {
        if (url.indexOf('?') > -1) {
          if (!url.endsWith('?')) {
            url += '&';
          }
        } else {
          url += '?';
        }
        url += queryStr;
      }
    }
    this.$admin.closeTabOrDialog(this, getUrlWithSign(url));
  };
};

/**
 * 获取显示上一单按钮的方法
 * @param storageKey 缓存在本地的key
 * @param routeType 路由数据的传输方式， 如query和params 默认是params
 * @param key 数据的唯一键，默认是id
 * @return {(function(): (boolean))|*}
 */
export const getShowLastBtnFn = ({storageKey, routeType = ROUTE_TYPE_PARAMS, key = 'id'}) => {
  return function () {
    // 从本地缓存中获取id列表
    const idArr = get(storageKey);
    if (!Array.isArray(idArr)) {
      return false;
    }
    const id = this.$admin.getTabRoute(this)[routeType][key];
    if (!id) {
      return false;
    }
    // 当前页面的id不在id列表中，当前页面的数据有可能是新增的
    const index = idArr.findIndex(item => id + '' === item + '');
    // index === -1表示当前页面的id不在id列表中，当前页面的数据有可能是新增的
    // index === 0 表示是第一元素，不显示上一单按钮
    if (index < 1) {
      return false;
    }
    return true;
  };
};
/**
 * 获取显示下一单按钮的方法
 * @param storageKey 缓存在本地的key
 * @param routeType 路由数据的传输方式， 如query和params 默认是params
 * @param key 数据的唯一键，默认是id
 * @return {(function(): (boolean))|*}
 */
export const getShowNextBtnFn = ({storageKey, routeType = ROUTE_TYPE_PARAMS, key = 'id'}) => {
  return function() {
    // 从本地缓存中获取id列表
    const idArr = get(storageKey);
    if (!Array.isArray(idArr)) {
      return false;
    }
    const id = this.$admin.getTabRoute(this)[routeType][key];
    if (!id) {
      return false;
    }
    // 当前页面的id不在id列表中，当前页面的数据有可能是新增的
    const index = idArr.findIndex(item => id + '' === item + '');
    // index === -1表示当前页面的id不在id列表中，当前页面的数据有可能是新增的
    // index === idArr.length - 1 表示是最后一个元素，不显示下一单按钮
    if (index === -1 || index === idArr.length - 1) {
      return false;
    }
    return true;
  };
};
/**
 * 用弹窗的方式打开
 * @type {string}
 */
export const OPEN_TYPE_DIALOG = 'dialog';
/**
 * 用页面的方式打开
 * @type {string}
 */
export const OPEN_TYPE_PAGE = 'page';
/**
 * 创建编辑按钮
 * @param shwo 是否显示按钮
 * @param vm
 * @param openType dialog表示打开弹窗，page表示打开新页面，默认dialog
 * @param name 按钮名称
 * @return {{default: (function(*, *): Array)}}
 */
export const createEditBtn = ({show, vm, openType = OPEN_TYPE_DIALOG, name = '编辑', code = 'edit'}) => {
  return {
    default: (scope, createElement) => {
      return renderTableOperateTemplate(scope, {
        list: [
          {
            name,
            // 只有最新版本的记录才显示编辑按钮
            show: ({item, data}) => {
              const row = data.row;
              if (!hasRight({code})) {
                return false;
              }
              if (Object.prototype.hasOwnProperty.call(row, 'isLast') && !data.row.isLast) {
                return false;
              }
              if (show) {
                return show({row: data.row, column: data.column})
              }
              return true;
            },
            click: ({row, data}) => {
              const column = data.column;
              if (openType === OPEN_TYPE_DIALOG) {
                vm.showDetail({row, cellValue: row[column.field], field: column.field, column: column, disabled: false});
              } else {
                vm.showDetail({row, cellValue: row[column.field], field: column.field, column: column, disabled: false});
              }
            }
          }
        ]
      }, createElement);
    }
  };
};
/**
 * 创建查看按钮
 * @param vm
 * @param openType dialog表示打开弹窗，page表示打开新页面，默认dialog
 * @param name 按钮显示的文字
 * @param show 是否显示
 * @return {{default: (function(*, *): Array)}}
 */
export const createViewBtn = ({vm, openType = OPEN_TYPE_DIALOG, name, show = () => {return true;}}) => {
  return {
    default: (scope, createElement) => {
      if (!show({scope})) {
        return null;
      }
      const $name = name || scope.row[scope.column.field];
      return renderTableOperateTemplate(scope, {
        list: [
          {
            name: $name,
            click: ({row, data}) => {
              const column = data.column;
              if (openType === OPEN_TYPE_DIALOG) {
                vm.showDetail({row, cellValue: row[column.field], field: column.field, column, disabled: true});
              } else {
                vm.showDetail({row, cellValue: row[column.field], field: column.field, column, disabled: true});
              }
            }
          }
        ]
      }, createElement);
    }
  }
};
/**
 * 将model对应字段的值转成fileList数组
 * @param item
 * @param model
 * @return {*|*[]}
 */
export const convertFileList = ({item, model}) => {
  const value = model[item.field];
  if (appUtils.isEmpty(value)) {
    return [];
  }
  let idArr = value;
  // 如果不是数组，就用逗号分隔
  if (!Array.isArray(value)) {
    idArr = value.split(',');
  }
  return idArr.map(item => {return {id: item}});
};
/**
 * 一般上传可选文件
 * @type {string}
 */
export const commonAccept = '.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.rar,.zip';
/**
 * 最多保留四位小数的正则表达式
 * @type {RegExp}
 */
export const precision4 = /^\d+(\.\d{1,4})?$/;
/**
 * 最多保留四位小数的正则表达式
 * @type {RegExp}
 */
export const precision2 = /^\d+(\.\d{1,2})?$/
/**
 * 正整数和0正则
 * @type {RegExp}
 */
export const integerReg = /(^[1-9]\d+$)|(^[0-9]$)/;

/**
 * 保留4位小数的校验方法
 * @param message
 * @param type 校验类型 el-form(element-ui) vxe-table(vxe-table), 默认el-form
 * @return {(function(*, *, *): void)|*}
 */
export const getPrecision4Validator = ({message, type = 'el-form'}) => {
  if (type === 'el-form') {
    return (rule, value, callback) => {
      if (!rule.required && appUtils.isEmpty(value)) {
        callback();
        return;
      }
      if (!precision4.test(value + '')) {
        callback(new RuleError(message));
      } else {
        callback();
      }
    };
  }
  // vxe-table的校验规则
  return ({ cellValue, rule }) => {
    if (!rule.required && appUtils.isEmpty(cellValue)) {
      return;
    }
    if (!precision4.test(cellValue + '')) {
      return new RuleError(message);
    }
  };
};
/**
 * 保留2位小数的校验方法
 * @param message
 * @param type 校验类型 el-form(element-ui) vxe-table(vxe-table), 默认el-form
 * @return {(function(*, *, *): void)|*}
 */
export const getPrecision2Validator = ({message = '最多保留两位小数', type = 'el-form'} = {}) => {
  if (type === 'el-form') {
    return (rule, value, callback) => {
      if (!rule.required && appUtils.isEmpty(value)) {
        callback();
        return;
      }
      if (!precision2.test(value + '')) {
        callback(new RuleError(message));
      } else {
        callback();
      }
    };
  }
  // vxe-table的校验规则
  return ({ cellValue, rule }) => {
    if (!rule.required && appUtils.isEmpty(cellValue)) {
      return;
    }
    if (!precision2.test(cellValue + '')) {
      return new RuleError(message);
    }
  };
};

/**
 * 整数校验方法
 * @param message
 * @param type 校验类型 el-form(element-ui) vxe-table(vxe-table), 默认el-form
 * @return {(function(*, *, *): void)|*}
 */
export const getIntegerValidator = ({message = '请输入整数', type = 'el-form'} = {}) => {
  if (type === 'el-form') {
    return (rule, value, callback) => {
      if (!rule.required && appUtils.isEmpty(value)) {
        callback();
        return;
      }
      if (!integerReg.test(value + '')) {
        callback(new RuleError(message));
      } else {
        callback();
      }
    };
  }
  // vxe-table的校验规则
  return ({ cellValue, rule }) => {
    if (!rule.required && appUtils.isEmpty(cellValue)) {
      return;
    }
    if (!integerReg.test(cellValue)) {
      return new RuleError(message);
    }
  };
};
/**
 * 使用记录失效，报错删除，作废，取消提交
 * @param url 接口地址
 * @param getParams 获取参数的方法
 * @param cb 作废成功过的回调方法
 * @param message 提示信息
 * @param method 请求方式
 * @return {(function(): Promise<void>)|*}
 */
export const invalidRecord = ({url, getParams, cb, message, method}) => {
  return async () => {
    await MessageBox.confirm(message, "提示");
    const obj = {
      url,
      method
    }
    if (method === 'post') {
      obj.data = getParams();
    } else {
      obj.params = getParams();
    }
    const res = await request(obj);
    if (res.isFail()) {
      Notification.error(res.msg);
      return;
    }
    Notification.success(res.msg);
    if (cb) {
      cb();
    }
  };
};

/**
 * 百分比格式化方法，默认最多保留两位小数，原值会乘以100
 * @param cellValue
 * @return {*|string}
 */
export const percentFormatter = ({cellValue}) => {
  if (appUtils.isEmpty(cellValue)) {
    return ''
  }
  return numeral(cellValue).format('0.[00]%');
};
/**
 * 百分比格式化方法，默认最多保留两位小数，原值不会乘以100
 * @param cellValue
 * @return {*|string}
 */
export const percentFormatter2 = ({cellValue}) => {
  if (appUtils.isEmpty(cellValue)) {
    return ''
  }
  return numeral(cellValue).format('0.[00]') + '%';
};
/**
 * 通用tooltip显示大写数字的方法
 * @param value
 * @returns {string}
 */
export const commonConvertBigDigit = ({value}) => {
  return convertBigDigit({num: value});
};
/**
 * 获取社区弹窗单选
 * @param span 宽度
 * @param label 标题
 * @return {{mode: string, newRow: boolean, field: string, columns: [{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string}], label: string, api: ((function(*): Promise)|*), type: string, conditionConfig: {labelWidth: string, model: {}, list: [{clearable: boolean, field: string, label: string, type: string},{clearable: boolean, field: string, label: string, type: string}]}, rowKey: string, updateFullData: updateFullData}}
 */
export const getCommunityItem = ({span = 6, label = '所属社区'} = {}) => {
  return {
    label,
    field: 'communityName',
    rowKey: 'name',
    span,
    width: '1000px',
    type: FIELD_TYPE_LIST_POP_ONE,
    mode: SIMPLE,
    updateFullData: ({data, model}) => {
      model.communityCode = data ? data.code : '';
    },
    api: (params) => {
      return request({
        url: '/api/auth/plCommunity/pagerScope',
        method: 'post',
        data: params
      });
    },
    conditionConfig: {
      labelWidth: '116px',
      model: {},
      list: [
        {
          field: 'code',
          label: '社区编码',
          type: FIELD_TYPE_INPUT,
          maxlength: 32,
          span: 8
        },
        {
          field: 'name',
          label: '所属社区',
          type: FIELD_TYPE_INPUT,
          maxlength: 32,
          span: 8
        },
        {
          field: 'status',
          label: '状态',
          type: FIELD_TYPE_SELECT,
          options: statusOptions,
          value: statusEffective,
          span: 8
        }
      ]
    },
    columns: [
      {field: 'code', title: '社区编码', align: 'center', minWidth: 300},
      {field: 'name', title: '社区名称', align: 'center', minWidth: 300},
      {field: 'status', title: '状态', align: 'center', width: 150, formatter: getOptionFormatter({options: statusOptions})}
    ]
  };
};
/**
 * 获取菜园弹窗单选
 * @param disabled
 * @param afterUpdateFullData 更新后的回调
 * @param span 宽度
 * @param label 标题
 * @param type 类型
 * @param validate 打开弹窗时的校验
 * @return {{mode: string, newRow: boolean, field: string, columns: [{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string}], label: string, api: ((function(*): Promise)|*), type: string, conditionConfig: {labelWidth: string, model: {}, list: [{clearable: boolean, field: string, label: string, type: string},{clearable: boolean, field: string, label: string, type: string}]}, rowKey: string, updateFullData: updateFullData}}
 */
export const getVegItem = ({disabled = false, afterUpdateFullData, span = 6, label = '菜园名称', getType, validate} = {}) => {
  return {
    label,
    field: 'vegName',
    rowKey: 'name',
    span,
    width: '90vw',
    type: FIELD_TYPE_LIST_POP_ONE,
    mode: SIMPLE,
    validate,
    disabled,
    updateFullData: ({data, model}) => {
      model.communityCode = data ? data.communityCode : '';
      model.communityName = data ? data.communityName : '';
      model.vegCode = data ? data.code : '';
      model.deposit = data ? data.deposit : '';
      model.mngFee = data ? data.mngFee : '';
      if (afterUpdateFullData) {
        afterUpdateFullData({data, model});
      }
    },
    api: vegPagerWithFee,
    conditionConfig: {
      labelWidth: '116px',
      model: {},
      list: [
        {
          field: 'code',
          label: '菜园编码',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'name',
          label: '菜园名称',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'communityCode',
          label: '社区编码',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'communityName',
          label: '所属社区名称',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'type',
          label: '类型',
          type: FIELD_TYPE_SELECT,
          disabled: true,
          options: typeOptions,
          valueMethod: getType
        },
        {
          field: 'status',
          label: '状态',
          type: FIELD_TYPE_SELECT,
          options: statusOptions,
          value: statusEffective
        },
        {
          field: 'isLast',
          label: '最新版本',
          type: FIELD_TYPE_SELECT,
          options: booleanOptions,
          disabled: true,
          value: true
        }
      ]
    },
    columns: [
      {field: 'code', title: '菜园编码', width: 170},
      {field: 'version', title: '版本', width: 50},
      {field: 'name', title: '菜园名称', width: 100},
      {
        field: 'fileId',
        title: '菜园地块地图',
        width: 200,
        className: 'attachment-cell',
        params: {},
        slots: {
          default: uploadColumnRender({disabled: true, accept: commonAccept, topTip: '<div style="font-size: 12px">只能上传一张，建议大小：宽度：750PX，高度：562PX</div>', limit: 1})
        }
      },
      {field: 'communityName', title: '所属社区名称', minWidth: 170},
      {field: 'communityCode', title: '所属社区编码', width: 100},
      {field: 'type', title: '类型', width: 100, formatter: getOptionFormatter({options: typeOptions})},
      {field: 'deposit', title: '押金', width: 100, sortable: true},
      {field: 'mngFee', title: '管理费用', width: 100, sortable: true},
      {field: 'isLast', title: '最新版本', width: 80, formatter: getOptionFormatter({options: booleanOptions})},
      {field: 'status', title: '状态', width: 50, formatter: getOptionFormatter({options: statusOptions})}
    ]
  };
};
/**
 * 获取地块弹窗单选
 * @param updateFullData 更新数据的回调函数
 * @param field 字段
 * @param span 宽度
 * @param label 标题
 * @param type 类型
 * @param validate 打开弹窗时的校验
 * @param plStatusDisabledMethod 地块状态是否禁用
 * @param plStatusOptions 地块状态下拉列表
 * @return {{mode: string, newRow: boolean, field: string, columns: [{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string}], label: string, api: ((function(*): Promise)|*), type: string, conditionConfig: {labelWidth: string, model: {}, list: [{clearable: boolean, field: string, label: string, type: string},{clearable: boolean, field: string, label: string, type: string}]}, rowKey: string, updateFullData: updateFullData}}
 */
export const getPlotItem = ({newRow = false, field = 'plotCode', updateFullData, span = 6, label = '地块编号', getType, validate, getVegCode, getVegName,getCommunityCode, getCommunityName, disabledMethod, plStatusDisabledMethod, plStatusOptions} = {}) => {
  return {
    label,
    field,
    rowKey: 'code',
    span,
    width: '90vw',
    type: FIELD_TYPE_LIST_POP_ONE,
    mode: SIMPLE,
    validate,
    newRow,
    updateFullData: ({data, model}) => {
      if (updateFullData) {
        updateFullData({data, model});
        return;
      }
      model.plotName = data.location;
    },
    disabledMethod,
    api: plPlotPager,
    conditionConfig: {
      labelWidth: '116px',
      model: {
        isLast: true
      },
      list: [
        {
          field: 'code',
          label: '地块编号',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'location',
          label: '位置',
          type: FIELD_TYPE_INPUT,
          maxlength: 100
        },
        {
          field: 'plStatus',
          label: '地块状态',
          type: FIELD_TYPE_SELECT,
          options: plStatusOptions || plotStatusOptions,
          disabledMethod: plStatusDisabledMethod,
          value: plotStatusClaimable
        },
        {
          field: 'type',
          label: '类型',
          type: FIELD_TYPE_SELECT,
          options: typeOptions,
          disabled: true,
          valueMethod: getType
        },
        {
          field: 'communityName',
          label: '所属社区',
          type: FIELD_TYPE_INPUT,
          toQuery: false,
          disabled: true,
          valueMethod: getCommunityName
        },
        {
          field: 'communityCode',
          label: '所属社区编码',
          type: FIELD_TYPE_INPUT,
          disabled: true,
          valueMethod: getCommunityCode
        },
        {
          field: 'vegName',
          label: '菜园名称',
          type: FIELD_TYPE_INPUT,
          toQuery: false,
          disabled: true,
          valueMethod: getVegName
        },
        {
          field: 'vegCode',
          label: '菜园编码',
          type: FIELD_TYPE_INPUT,
          disabled: true,
          valueMethod: getVegCode
        },
        {
          field: 'status',
          label: '系统状态',
          type: FIELD_TYPE_SELECT,
          options: statusOptions,
          value: statusEffective,
          disabled: true
        }
      ]
    },
    columns: [
      {field: 'code', title: '地块编号', width: 170},
      {field: 'location', title: '位置', width: 100},
      {field: 'area', title: '面积(㎡)', width: 160},
      {field: 'plStatus', title: '地块状态', width: 140, formatter: getOptionFormatter({options: plotStatusOptions})},
      {field: 'type', title: '类型', width: 160, formatter: getOptionFormatter({options: typeOptions})},
      {field: 'deposit', title: '押金金额', width: 160, sortable: true},
      {field: 'mngFee', title: '管理费用金额', width: 160, sortable: true},
      {field: 'dayLimit', title: '租赁期限（按天）', width: 160, sortable: true},
      {field: 'vegName', title: '菜园名称', width: 160},
      {field: 'vegCode', title: '菜园编码', width: 160}
    ]
  };
};
/**
 * 获取申请记录弹窗单选
 * @param handleQueryParams
 * @param span 宽度
 * @param label 标题
 * @param type 类型
 * @param validate 打开弹窗时的校验
 * @return {{mode: string, newRow: boolean, field: string, columns: [{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string}], label: string, api: ((function(*): Promise)|*), type: string, conditionConfig: {labelWidth: string, model: {}, list: [{clearable: boolean, field: string, label: string, type: string},{clearable: boolean, field: string, label: string, type: string}]}, rowKey: string, updateFullData: updateFullData}}
 */
export const getApplyItem = ({handleQueryParams, span = 6, label = '关联申请记录编号', getType, validate, getVegCode, getVegName,getCommunityCode, getCommunityName, disabledMethod} = {}) => {
  return {
    label,
    field: 'applyCode',
    rowKey: 'orderNo',
    span,
    width: '90vw',
    type: FIELD_TYPE_LIST_POP_ONE,
    mode: SIMPLE,
    validate,
    handleQueryParams,
    updateFullData: ({data, model}) => {
      model.communityCode = data ? data.communityCode : '';
      model.communityName = data ? data.communityName : '';
      model.vegCode = data ? data.vegCode : '';
      model.vegName = data ? data.vegName : '';
      model.deposit = data ? data.deposit : 0;
      model.mngFee = data ? data.mngFee : 0;
    },
    disabledMethod,
    api: plApplyPager,
    conditionConfig: {
      labelWidth: '116px',
      model: {},
      list: [
        {
          field: 'orderNo',
          label: '申请单号',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'applyName',
          label: '申请人姓名',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'phone',
          label: '申请人手机号',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'idNum',
          label: '身份证号',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'communityCode',
          label: '所属社区编码',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'communityName',
          label: '所属社区名称',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'vegCode',
          label: '菜园编码',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'vegName',
          label: '菜园名称',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        }
      ]
    },
    columns: [
      {field: 'orderNo', title: '申请单号', width: 170},
      {field: 'orderDate', title: '单据日期', width: 100, sortable: true},
      {field: 'communityName', title: '所属社区', width: 160},
      {field: 'communityCode', title: '所属社区编码', width: 140},
      {field: 'vegCode', title: '菜园编码', width: 160},
      {field: 'vegName', title: '菜园名称', width: 160},
      {field: 'applyName', title: '申请人姓名', width: 160},
      {field: 'phone', title: '申请人手机号', width: 160},
      {field: 'idNum', title: '身份证号', width: 160},
      {field: 'address', title: '当前住址', width: 160},
      {field: 'type', title: '申请类型', width: 160, formatter: getOptionFormatter({options: typeOptions})},
      {field: 'conUnit', title: '共建单位名称', width: 160},
      {field: 'progress', title: '总进度', width: 160, formatter: getOptionFormatter({options: progressOptions})},
      {field: 'reviewProgress', title: '审核进度', width: 160, formatter: getOptionFormatter({options: reviewProgressOptions})},
      {field: 'reviewerName', title: '审核人', width: 160},
      {field: 'reviewTime', title: '审核时间', width: 160, sortable: true},
      {field: 'overdueDate', title: '逾期时间', width: 160, formatter: dateToDateTimeFormatter, sortable: true},
      {field: 'deposit', title: '押金金额', width: 160, sortable: true},
      {field: 'mngFee', title: '管理费用金额', width: 160, sortable: true}
    ]
  };
};
/**
 * 获取申请记录弹窗单选
 * @param handleQueryParams 处理queryParams的回调函数
 * @param span 宽度
 * @param label 标题
 * @param type 类型
 * @param validate 打开弹窗时的校验
 * @return {{mode: string, newRow: boolean, field: string, columns: [{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string},{field: string, width: number, title: string, align: string}], label: string, api: ((function(*): Promise)|*), type: string, conditionConfig: {labelWidth: string, model: {}, list: [{clearable: boolean, field: string, label: string, type: string},{clearable: boolean, field: string, label: string, type: string}]}, rowKey: string, updateFullData: updateFullData}}
 */
export const getApplyItem2 = ({handleQueryParams, span = 6, label = '关联申请记录编号', getType, validate, getVegCode, getVegName,getCommunityCode, getCommunityName, disabledMethod, $progressOptions = progressOptions} = {}) => {
  return {
    label,
    field: 'applyCode',
    rowKey: 'orderNo',
    span,
    width: '90vw',
    type: FIELD_TYPE_LIST_POP_ONE,
    mode: SIMPLE,
    validate,
    ref: 'applyCodeSearchList',
    handleQueryParams,
    updateFullData: ({data, model}) => {
      model.communityCode = data ? data.communityCode : '';
      model.communityName = data ? data.communityName : '';
      model.vegCode = data ? data.vegCode : '';
      model.vegName = data ? data.vegName : '';
      model.deposit = data ? data.deposit : '';
      if (model.bizType === depositOut) {
        model.amount = data ? data.deposit : '';
        model.mngFee = '0';
      } else {
        model.mngFee = data ? data.mngFee : '';
        model.amount = numeral(isEmpty(model.deposit) ? 0 : model.deposit).add(isEmpty(model.mngFee) ? 0 : model.mngFee).format('0.[00]');
      }
      // model.deposit = data ? data.deposit : '';
    },
    disabledMethod,
    api: plApplyPager,
    conditionConfig: {
      labelWidth: '116px',
      model: {},
      list: [
        {
          field: 'orderNo',
          label: '申请单号',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'applyName',
          label: '申请人姓名',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'phone',
          label: '申请人手机号',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        },
        {
          field: 'progress',
          label: '总进度',
          type: FIELD_TYPE_SELECT,
          options: $progressOptions
        },
        {
          field: 'idNum',
          label: '身份证号',
          type: FIELD_TYPE_INPUT,
          maxlength: 32
        }
      ]
    },
    columns: [
      {field: 'orderNo', title: '申请单号', width: 170},
      {field: 'orderDate', title: '单据日期', width: 100, sortable: true},
      {field: 'communityName', title: '所属社区', width: 160},
      {field: 'communityCode', title: '所属社区编码', width: 140},
      {field: 'vegCode', title: '菜园编码', width: 160},
      {field: 'vegName', title: '菜园名称', width: 160},
      {field: 'applyName', title: '申请人姓名', width: 160},
      {field: 'phone', title: '申请人手机号', width: 160},
      {field: 'idNum', title: '身份证号', width: 160},
      {field: 'address', title: '当前住址', width: 160},
      {field: 'type', title: '申请类型', width: 160, formatter: getOptionFormatter({options: typeOptions})},
      {field: 'conUnit', title: '共建单位名称', width: 160},
      {field: 'progress', title: '总进度', width: 160, formatter: getOptionFormatter({options: progressOptions})},
      {field: 'deposit', title: '押金金额', width: 160, sortable: true},
      {field: 'mngFee', title: '管理费用金额', width: 160, sortable: true}
    ]
  };
};
/**
 * 创建输入框筛选
 * @returns {{filters: [{data: string}], filterRender: {nativeEvents: {keyup: *}, name: string, attrs: {placeholder: string}}}}
 */
export const createInputFilter = () => {
  return {
    filters: [{data: ''}],
    filterRender: {
      name: 'ElInput',
      attrs: {
        placeholder: '选择回车筛选'
      },
      nativeEvents: {
        keyup: ({$panel}, event) => {
          if (event.keyCode === 13) {
            $panel.confirmFilter();
          }
        }
      }
    }
  };
};

export const dateToDateTimeFormatter = ({cellValue, time = '23:59:59'}) => {
  if (isEmpty(cellValue)) {
    return cellValue;
  }
  return cellValue + ' ' + time;
}